import React from "react";
import { useParams, Navigate } from "react-router-dom";
import ResetPasswordForm from "./ResetPasswordForm";
import { LoginContainer, LoginCard, Title, LogoImg } from "./Login.styles.js";

import logoImage from "../../images/logo_ylhq.png";

const ResetPasswordPage = () => {
  const { token } = useParams();

  if (!token) {
    return <Navigate to="/#forgot-password" />;
  }

  return (
    <LoginContainer>
      <LoginCard>
        <LogoImg src={logoImage} alt="Yellow Letter HQ Logo" />
        <Title>Reset Your Password</Title>
        <ResetPasswordForm token={token} />
      </LoginCard>
    </LoginContainer>
  );
};

export default ResetPasswordPage;
